import React         from 'react';
import FileComponent from './FileComponentFC';

const GerberFile = (props) => {
  const { parameters, errorMessage } = props
  const name = 'filename'
  const value = parameters[name]
  const isRequired = value === '' || value === undefined;
  return (
    <div className="form-group">
      <FileComponent
        id={props.inputId}
        label={props.label}
        text={props.text}
        fileName={value}
        isFileRequired={isRequired}
        {...props} />
      {errorMessage}
      <div id="error_gerber_files" />
    </div>
  );
};

GerberFile.defaultProps = {
  inputClassName: 'ignore-on-quote',
  inputId       : 'gerber-file',
  label         : 'File Upload',
  text: 'Browse file',
};

export default GerberFile;
